// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionStyle: 'style2',
		//suggestionStyle2MainContainerSelector: '#shopify-section-header',
		suggestionMobileStyle: 'style2',
      	enableFuzzy: false,
      	fullMinMatch: true,
      	enableDefaultResult: false,
	}
};
var bcThis;
//Set theme search mode to product only
window.theme.searchMode = 'product';

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	SearchInput.prototype.beforeBindEvents = function (id) {
		var id = this.id;
		if (id == Class.searchBox + '-0') {
			this.$element = removeThemeSearchEvent();
			this.instantSearchResult.$searchInputElement = this.$element;
		}
		recallThemeOnPageShowEvent();

		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	function removeThemeSearchEvent() {
		// Remove all events
		if (jQ('[name="q"]').length > 0) {
			var cloneSearchBar = jQ('[name="q"]').first().clone();
			jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
			jQ('[name="q"]').first().replaceWith(cloneSearchBar);
			if (jQ('#Search').length > 0) {
				if (jQ('#Search').hasClass('Modal--fullScreen')) {
					jQ('#Search').attr("style", "height: 0px !important");
				}
				jQ('#Search .Search__Results').attr("style", "display: none !important");
			}

			// Rebuild click search icon event
			if (jQ('[data-action="toggle-search"]').length > 0) {
				jQ('[data-action="toggle-search"]').on('click', function () {
					setTimeout(function () {
						jQ('[name="q"]:first').focus();
					}, 500);
				})
			}
		}
		// disable page transition
		if (window.theme && window.theme.showPageTransition) {
			window.theme.showPageTransition = false;
		}
		return cloneSearchBar;
	}

	function recallThemeOnPageShowEvent() {
		// disable page transition
		var pageTransition = document.querySelector('.PageTransition');
		if (pageTransition) {
			pageTransition.style.visibility = 'visible';
			pageTransition.style.opacity = '0';
		}
		// refresh cart
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
			bubbles: true
		}));
	}

	InstantSearchResultItemProduct.prototype.prepareSuggestionProductPriceData = function() {
		var currenciesSeting = Settings.getSettingValue('general.currencies');

		if (typeof currenciesSeting != 'undefined' && currenciesSeting.length > 1) {
			var currentCurrency = Settings.getSettingValue('general.current_currency').toLowerCase().trim();
			var prices = ['price_min', 'price_max', 'compare_at_price_min', 'compare_at_price_max'];
			prices.forEach((priceKey) => {
				var currentPriceKey = priceKey + '_' + currentCurrency;
				if (typeof this.data[currentPriceKey] !== 'undefined') {
					this.data[priceKey] = this.data[currentPriceKey];
				}
			});
		}

		var minPrice = 999999999;
      	this.data.variants.forEach(v => {
          if (v.available && (v.price < minPrice)) {
			minPrice = v.price;
		  }
      	});

		var obj = this.data.variants.find(v => v.price == minPrice);
        if (obj) {
          this.data.price_min = parseFloat(minPrice);
          this.data.compare_at_price_min = parseFloat(obj.compare_at_price);
        }
	}
        
    
    InstantSearchResult.prototype._renderWrapper = function() {
		var mobileClass = Utils.InstantSearch.isFullWidthMobile() ? Class.searchSuggestionMobile : '';
		if (mobileClass !== '') {
			this.$wrapper.addClass(mobileClass);
		}
		bcThis = this;
		// Set suggestion wrapper, popover, and ul position
		var suggestionPosition = this._setSuggestionPosition();
		suggestionPosition.setSuggetionPosition();
		suggestionPosition.setSuggetionPopoverPosition();

		// Set suggestion width
		var width = '';
		if (Settings.getSettingValue('search.suggestionWidth') == 'auto' || Utils.isMobile()) {
			width = this.$searchInputElement[0].getBoundingClientRect().width;
		} else {
			width = Settings.getSettingValue('search.suggestionWidth');
		}
		this.$wrapper.css({width: width});
	}
    
    
    InstantSearchResult.prototype._setSuggestionPosition = function() {
		var searchInputRect = this.$searchInputElement[0].getBoundingClientRect();
		var topPosition = Utils.InstantSearch.isFullWidthMobile() ? searchInputRect.bottom : searchInputRect.bottom + 12;
		var topPx = '';
		var leftPx = '';
		var rightPx = '';
		var maxHeight = Settings.getSettingValue('search.suggestionMaxHeight');
		if (maxHeight + topPosition > jQ(window).height()) {
			maxHeight = jQ(window).height() - topPosition - 30;
		}
		var maxHeightPx = maxHeight + 'px';

		if (this.suggestionDirection == 'left') {
			topPx = (topPosition + window.scrollY) + 'px';
			leftPx = searchInputRect.left + 'px';

			if (Utils.isMobile()) {
				this.$wrapper.css({
					top: topPx,
					right: '10px',
					left: '10px',
				})
			} else {
				this.$wrapper.css({
					top: topPx,
					left: leftPx
				})
			}

			var setSuggetionPosition = () => {
				this.$instantSearchResult.css({
					top: '0px',
					left: '0px',
					'max-height': maxHeightPx
				})
			};
			var setSuggetionPopoverPosition = () => {
				this.$popoverElement.css({
					top: '-20px',
					left: '20px'
				})
			};
		} else {
			topPx = topPosition + 'px';
			rightPx = (window.innerWidth - searchInputRect.right) + 'px';

			if (Utils.isMobile()) {
				this.$wrapper.css({
					top: topPx,
					right: '10px',
					left: '10px',
				})
			} else {
				this.$wrapper.css({
					top: topPx,
					right: rightPx
				})
			}

			var setSuggetionPosition = () => {
				this.$instantSearchResult.css({
					top: '0px',
					right: '0px',
					'max-height': maxHeightPx
				})
			};
			var setSuggetionPopoverPosition = () => {
				this.$popoverElement.css({
					top: '-20px',
					right: '20px'
				})
			};
		}

		return {
			setSuggetionPosition: setSuggetionPosition,
			setSuggetionPopoverPosition: setSuggetionPopoverPosition
		}
	}

// 	InstantSearchResult.prototype.bindEvents = function() {
// 		window.addEventListener('resize', this._setSuggestionPosition.bind(this));
//       	window.addEventListener('scroll', this._setSuggestionPosition.bind(this));
// 	}
    
    SearchInput.prototype.bindEvents = function(){
      // Bind events on search input
      this.$element
      .on('click', this._onClickSearchBox.bind(this))
      .on('focus', this._onFocusSearchBox.bind(this))
      .on('keyup', this._onTypeSearchBoxEvent.bind(this));
      // Build search submit event
      if (this.$searchForm.length) {
        this.$searchForm.on('submit', this._onSubmit.bind(this));
      }
      this.isBoundEvents = true;
      var self = this;
      window.addEventListener('scroll', function(){
        if (self.instantSearchResult && self.instantSearchResult.$instantSearchResult && self.instantSearchResult.$wrapper) {
          /**
			 * Test Mode - Turn on when need check elements of Auto Complete
			 * Prevent closing Auto complete when opening Inspect Element
			 */
          if (Settings.getSettingValue('search.suggestionMode') == 'test' || Utils.InstantSearch.isFullWidthMobile()) {
            self.instantSearchResult.$instantSearchResult.show();
          } else {
            self.instantSearchResult.$instantSearchResult.siblings().hide();
          }
          if (!Utils.isiOS()) {
            self.instantSearchResult.$wrapper.removeClass(Class.searchSuggestionOpen);
          }
        }
      });
    }
})();